import { Directions, withProps } from '../common'

const Direction = ({ children, direction=Directions.RTL }) => {
  return <div style={{height:'100%'}}>{withProps(children, { direction })}</div>
}

export default Direction
